import { LocationListModel } from './location-list.model';
import { MediaModel } from './media.model';
import { PoiListModel } from './poi-list.model';
import { PropertyListModel } from './property-list.model';
import { PropertyTypeListModel } from './property-type-list.model';

export class StaticPageModel {
  Name?: string;
  Url?: string;
  Title?: string;
  MetaDescription?: string;
  Description?: string;
  ListHeader?: string;
  ShowLocations?: boolean;
  ShowPois?: boolean;
  ShowSearchBox?: boolean;
  ShowPropertyTypes?: boolean;
  ShowTopProperties?: boolean;
  Media?: MediaModel = new MediaModel();
  Locations?: LocationListModel[];
  Pois?: PoiListModel[];
  PropertyTypes?: PropertyTypeListModel[];
  TopProperties?: PropertyListModel[];
}
